export const convertToPercent = (number: number): number => {
  return number * 100;
};
